<template>
  <div>
    <v-layout row>
      <v-flex>
        <v-card width="100%">
          <v-card-text>
            <v-layout class="title" align-baseline>
              <v-flex xs2>
                {{ $t('commodityInfo') }}:
              </v-flex>
              <v-flex xs3>
                <v-btn dark color="primary" @click="showCommodityEditPopup({}, 'add')">{{$t('addCommodity')}}</v-btn>
              </v-flex>
              <v-flex class="red--text font-weight-bold text-xs-right" v-if="errorMessage">
                {{ errorMessage }}
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="commodityHeaders"
              :items="value"
              hide-actions
              class="elevation-2 mt-2"
            >
              <template v-slot:items="props">
                <td class="subheading">{{props.item.productName}}</td>
                <td class="text-xs-left">{{props.item.productCNName}}</td>
                <td class="text-xs-left">{{props.item.countryOfOrigin}}</td>
                <td class="text-xs-left">{{props.item.harmonizedCode}}</td>
                <td class="text-xs-left">{{props.item.quantity}}</td>
                <td class="text-xs-left">${{props.item.unitPrice}}</td>
                <!-- <td class="text-xs-left">{{props.item.weight}}</td> -->
                <td class="text-xs-left">{{props.item.material}}</td>
                <td class="text-xs-left">{{props.item.commodityDescription}}</td>
                <td class="text-xs-center" v-if="actionFrom === 'createLabel'">
                  <v-btn icon @click="showCommodityEditPopup(props, 'edit')"><v-icon>edit</v-icon></v-btn>
                  <v-btn icon @click="deleteCommodity(props.index)"><v-icon>delete</v-icon></v-btn>
                </td>
              </template>
            </v-data-table>
            <FormSubmitPopup
              :title="actionType === 'add' ? $t('addCommodity') : $t('editCommodity')"
              v-model="isShowEditCommodityPopup"
              :leftMethod="closeEditCommodityPopup"
              :rightMethod="onSubmit"
              large
             >
              <template v-slot:input>
                <v-card-text>
                  <!-- <v-layout justify-space-between>
                    <v-flex xs4>
                      <v-menu 
                        offset-y
                        :close-on-content-click="false"
                        v-model="menuProfile"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            ref="profile"
                            :label="$t('savedCommodity')"
                            persistent-hint
                            v-model="searchText"
                            @click.stop="on.click"
                            @keyup.enter="getCommodities"
                            v-if="!(isCommodityUnchangeable && actionFrom === 'createLabel')"
                          >
                            <template v-slot:append>
                              <LoaderButton
                                flat
                                isSmall
                                :promiseAwait="getCommodities"
                                :buttonText="$t('search')"
                                :disabled="isCommodityUnchangeable && actionFrom === 'createLabel'"
                              ></LoaderButton>
                            </template>
                          </v-text-field>
                        </template>
                        <v-list v-if="searchedCommodities && searchedCommodities.length">
                          <v-list-tile 
                            v-for="item in searchedCommodities" 
                            :key="item.requestId" 
                            @click.stop="() => onSelectCommodity(item)"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.profileName }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon @click.stop="() => removeCommodityDb(item)">delete</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout> -->
                  <v-form ref="form" lazy-validation>
                    <v-layout align-baseline justify-space-between>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('productName')"
                          :rules="[
                            fieldIsRequired()
                          ]"
                          class="required_field"
                          v-model="commodityInEdit.productName"></v-text-field>    
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('productCNName')"
                          :rules="[
                            fieldIsRequired()
                          ]"
                          class="required_field"
                          v-model="commodityInEdit.productCNName"></v-text-field>    
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          hide-details
                          :items="countryCodeArray"
                          item-text="name"
                          item-value="value"
                          :rules="[fieldIsRequired()]"
                          class="required_field"
                          v-model="commodityInEdit.countryOfOrigin"
                          :label="$t('countryOfOrigin')"
                          ></v-autocomplete> 
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('harmonizedCode')"
                          v-model="commodityInEdit.harmonizedCode"
                          :rules="[fieldIsRequired()]"
                          class="required_field"
                          ></v-text-field>  
                      </v-flex>
                    </v-layout>
                    <v-layout align-baseline justify-space-between>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('quantity')"
                          :rules="[fieldIsNumber(), fieldIsRequired()]"
                          :class="'required_field'"
                          v-model.number="commodityInEdit.quantity"></v-text-field>    
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('unitPrice')"
                          :rules="[fieldIsNumber(), fieldIsRequired()]"
                          :class="'required_field'"
                          v-model.number="commodityInEdit.unitPrice"></v-text-field>    
                      </v-flex>
                      <!-- <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('weight')"
                          :rules="[fieldIsNumber(), fieldIsRequired()]"
                          :class="'required_field'"
                          v-model.number="commodityInEdit.weight"></v-text-field>    
                      </v-flex> -->
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :label="$t('material')"
                          :rules="[fieldIsRequired()]"
                          :class="'required_field'"
                          v-model="commodityInEdit.material"></v-text-field>    
                      </v-flex>
                      <v-flex xs2></v-flex>
                    </v-layout>
                    <v-layout align-baseline justify-space-between>
                      <v-flex xs12>
                        <v-text-field
                          hide-details
                          :label="$t('description')"
                          v-model="commodityInEdit.commodityDescription"></v-text-field>    
                      </v-flex>
                    </v-layout>
                  </v-form>
                  <!-- <v-layout justify-end align-baseline>
                    <v-flex xs2>
                      <v-text-field
                        v-if="isSaveCommodityProfile"
                        hide-details
                        v-model.trim="profileName"
                        class="required_field"
                        :rules="[fieldIsRequired()]"
                        :label="$t('profileName')"></v-text-field>    
                    </v-flex>
                    <v-flex xs2 v-if="actionType === 'add' && actionType !== 'edit'">
                      <v-checkbox :label="$t('saveCommodityProfile')" hide-details class="checkbox" v-model="isSaveCommodityProfile"></v-checkbox>
                    </v-flex>
                  </v-layout> -->
                </v-card-text>
              </template>
            </FormSubmitPopup>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import { checkRules, timeTools, measurementTools, toMoney } from '@/utils/tools'
import LoaderButton from './LoaderButton'
import FormSubmitPopup from './FormSubmitPopup'
export default {
  name: 'CommodityWidget',
  components: {
    LoaderButton,
    FormSubmitPopup
  },
  data () {
    return {
      commodityInEdit: {
        // weight: '',
        productName: '',
        productCNName: '',
        material: '',
        // purpose: '',
        countryOfOrigin: 'CN',
        harmonizedCode: '',
        // customsValue: '',
        quantity: '',
        unitPrice: '',
        commodityDescription: ''
      },
      isSaveCommodityProfile: false,
      searchedCommodities: [],
      searchText: '',
      selectedCommodity: {},
      menuProfile: false,
      errorMessage: '',
      isShowEditCommodityPopup: false,
      actionType: '',
      commonCommodity: '',
      profileName: ''
    }
  },
  mixins: [checkRules, timeTools, measurementTools],
  computed: {
    totalCommodityInfo () {
      return this.value.reduce((obj, item) => {
        obj.quantity += item.quantity
        obj.price += item.unitPrice * item.quantity
        return obj
      }, {
        quantity: 0,
        price: 0
      })
    },
    countryCodeArray () {
      return this.$store.getters.countryCodeArray
    },
    commodityHeaders () {
      const { quantity, price } = this.totalCommodityInfo
      const rows = [
        { text: this.$t('productName'), value: 'productName', align: 'left', sortable: false },
        { text: this.$t('productCNName'), value: 'productCNName', align: 'left', sortable: false },
        { text: this.$t('countryOfOrigin'), value: 'countryOfOrigin', align: 'left', sortable: false },
        { text: this.$t('harmonizedCode'), value: 'harmonizedCode', align: 'left', sortable: false },
        { text: `${this.$t('quantity')}(${quantity})`, value: 'quantity', align: 'left', sortable: false },
        { text: `${this.$t('unitPrice')}(${toMoney(price)})`, value: 'unitPrice', align: 'left', sortable: false },
        // { text: this.$t('weight'), value: 'weight', align: 'left', sortable: false },
        { text: this.$t('material'), value: 'material', align: 'left', sortable: false },
        { text: this.$t('description'), value: 'commodityDescription', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false }
      ] 
      return rows
    }
  },
  methods: {
    async onSubmit () {
      switch (this.actionType) {
        case 'add':
          await this.addCommodity()
          break
        case 'edit':
          this.updateCommodity()
          break
        default:
          break
      }
    },
    async addCommodity () {
      if (!this.$refs[`form`].validate()) return
      // if (this.isSaveCommodityProfile && !this.profileName) {
      //   this.errorMessage = this.$t('profileNameIsMissing')
      //   return
      // }
      const value = { ...this.commodityInEdit }
      // if (this.isSaveCommodityProfile) {
      //   let target = await this.$store.dispatch('getCommodityKey', {keyword: this.profileName.trim()})
      //   if (target) {
      //     this.$store.dispatch('addCommodity', {...value, isUpdate: true, key: target})
      //     const targetCommodityInfo = this.searchedCommodities.find(item => item.key === target)
      //     targetCommodityInfo && Object.assign(targetCommodityInfo, value, {isMeasurementMetric: this.isMeasurementMetric})
      //   } else {
      //     this.$store.dispatch('addCommodity', value)
      //   }
      //   this.isSaveCommodityProfile = false
      // }
      this.$emit('input', [...this.value, value])
      this.closeEditCommodityPopup()
    },
    deleteCommodity (index) {
      this.$emit('input', this.value.filter((item, i) => index !== i))
    },
    showCommodityEditPopup (props, type) {
      if (type === 'edit') {
        const {item, index} = props
        Object.assign(this.commodityInEdit, {...item, indexNum: index})
      }
      this.actionType = type
      this.isShowEditCommodityPopup = true
    },
    closeEditCommodityPopup () {
      this.isShowEditCommodityPopup = false
      this.$nextTick(() => {
        this.resetPopupDataInEdit()
      })
    },
    updateCommodity () {
      const {indexNum, ...rest} = this.commodityInEdit
      this.$emit('input', [...this.value].map((item, index) => {
        if (index === indexNum) {
          return rest
        }
        return item
      }))
      this.closeEditCommodityPopup()
    },
    resetPopupDataInEdit () {
      this.searchText = ''
      this.isSaveCommodityProfile = false
      this.commonCommodity = ''
      this.profileName = ''
      this.commodityInEdit = {
        // weight: '',
        productName: '',
        productCNName: '',
        material: '',
        // purpose: '',
        countryOfOrigin: 'CN',
        // customsValue: '',
        quantity: '',
        unitPrice: '',
        commodityDescription: '',
        harmonizedCode: ''
      }
      const $form = this.$refs[`form`]
      $form && $form.resetValidation()
    }
  },
  props: {
    value: Array,
    carrier: {
      type: String,
      default: 'FEDEX'
    },
    actionFrom: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  .qty_unit_filed /deep/ .v-input__append-outer {
    margin: 0;
  }
  .qty_unit {
    margin: 0;
    padding: 0;
  }

  .qty_unit /deep/ label::after {
    content: "";
  }
</style>



// WEBPACK FOOTER //
// src/components/ImportUSCommodityWidget.vue